exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-centralised {\n  display: flex;\n}\n.container-centralised .container-centralised-content {\n  vertical-align: middle;\n  display: table-cell;\n  margin: auto;\n}\n.container-centralised .container-centralised-content .container-body {\n  margin: 0 auto;\n  border-radius: 5px;\n  max-height: 100vh;\n}\n.container-centralised .container-centralised-content .container-body-md {\n  width: 300px;\n}", ""]);

// exports
